/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamsConnectionPartialUpdate
 */
export interface TeamsConnectionPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof TeamsConnectionPartialUpdate
     */
    name?: string;
}

export function TeamsConnectionPartialUpdateFromJSON(json: any): TeamsConnectionPartialUpdate {
    return TeamsConnectionPartialUpdateFromJSONTyped(json, false);
}

export function TeamsConnectionPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsConnectionPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TeamsConnectionPartialUpdateToJSON(value?: TeamsConnectionPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


